import { init, ErrorBoundary } from '@sentry/react';
import type { ChildrenProps } from 'types';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: `metis@${process.env.REACT_APP_VERSION || '0.0.0'}`,
  });
}

const ErrorFallback = () => (
  <div className="h-screen w-full flex flex-col items-center justify-center">
    <p className="text-lg font-semibold">Something went wrong.</p>
    <p className="text-sm text-gray-500">
      Please refresh the page. Our team has been notified.
    </p>
  </div>
);

const SentrySetting = ({ children }: ChildrenProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>{children}</ErrorBoundary>
);

export default SentrySetting;
